import { httpService } from '@/services/HttpService';

class LimitsService {
  getLimits(workspaceId: number, regionId: number): Promise<any> {
    return httpService.get(
      `workspaces/${workspaceId}/regions/${regionId}/usage_limit`,
      {},
      { isAuthErrorSuppressed: true }
    );
  }
  getCurrentUsage(workspaceId: number, regionId: number): Promise<any> {
    return httpService.get(
      `workspaces/${workspaceId}/regions/${regionId}/current_usage`,
      {},
      {
        isAuthErrorSuppressed: true,
      }
    );
  }
}

export const limitsService = new LimitsService();
